"use client"

import clsx from "clsx"
import { useStickyHeaderProps } from "src/checkout/layout/stickyHeader"
import { NpAnnouncement } from "src/components/np-design/sections/header/NpAnnouncement"
import { NpHeader } from "src/components/np-design/sections/header/NpHeader"
import { SanityAnnouncementData } from "src/data/sanity/types"

export type NpStickyHeaderProps = {
  announcement?: SanityAnnouncementData | null
  checkout?: boolean
}

export const NpStickyHeader = ({ announcement, checkout }: NpStickyHeaderProps) => {
  const { stickyRef, stickyClassName } = useStickyHeaderProps()

  return (
    <>
      <div
        className={clsx("bg-white", {
          "h-16 lg:h-20": !announcement,
          "h-32 lg:h-30": announcement,
        })}
      />

      <div ref={stickyRef} className={clsx(stickyClassName, "shadow backdrop-blur-lg")}>
        {announcement && <NpAnnouncement {...announcement} />}
        <NpHeader checkout={checkout} announcement={announcement} />
      </div>
    </>
  )
}
